module.exports = __webpack_public_path__ + "static/img/1.4a494d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chongqing/1.jpg
// module id = omTv
// module chunks = 1